import { Swiper, SwiperSlide } from 'swiper/vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import 'swiper/css';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import log from '@/logger';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [loaderMixin],
  props: {
    num: {
      type: Number,
      default: 3,
    },
  },
  components: {
    marketListItem: marketListItemV2,
    swiper: Swiper,
    swiperSlide: SwiperSlide,
  },
  data() {
    return {
      activeIndex: 0,
      swiperInstance: null,
      swiperOptions: {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('browse', ['newArrivalMarkets']),
    title() {
      return 'New Arrivals';
    },
    items() {
      return this.newArrivalMarkets;
    },
    isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === this.num - 1;
    },
    prevArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--left': true,
        'most-predicted__header-arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--right': true,
        'most-predicted__header-arrow--disabled': this.isNextArrowDisabled,
      };
    },
  },
  methods: {
    ...mapActions('browse', ['getNewArrivalMarkets']),
    onSwiperReady(swiperInstance) {
      this.swiperInstance = swiperInstance;
    },
    onTransitionStart(swp) {
      this.activeIndex = swp.activeIndex;
    },
    prevSlide() {
      if (!this.isPrevArrowDisabled) this.swiperInstance.slidePrev();
    },
    nextSlide() {
      if (!this.isNextArrowDisabled) this.swiperInstance.slideNext();
    },
  },
  mounted() {
    const payload = {
      limit: this.num,
    };

    this.loaderAdd();

    this.getNewArrivalMarkets(payload)
      .then(() => {
        this.isComponentReady = true;
      })
      .catch((error) => log.error('Request failed.', error))
      .finally(() => this.loaderRemove());
  },
};
